// extracted by mini-css-extract-plugin
export default {"wrapper":"vX-z","availablePromoMessagesLabel":"wX-z","promoMessageList":"xX-z","promoMessage":"yX-z","appliedPromoMessage":"zX-z","promoMessageAmount":"AX-z"};